import React from "react";
import snackImg1 from "./assets/catagorypng/part_2_eco.png";

function ShopebyCategories() {
  return (
    <div className="bg-white pt-10 pb-8 px-6 sm:px-8 md:px-10">
      
      {/* Heading */}
      <div className="text-center mb-10">
        <h2 className="font-bold text-3xl sm:text-4xl md:text-5xl leading-tight">
          Making Process of our Products!
        </h2>
      </div>

      {/* Responsive Image Container */}
      <div className="flex justify-center">
        <div className="w-full max-w-6xl px-4">
          <div className="flex flex-col items-center rounded-lg hover:shadow-md transition-all">
            <div className="w-full sm:w-[500px] h-auto sm:h-[200px]">
              <img
                src={snackImg1}
                alt="Making Process"
                className="w-full h-full object-contain"
              />
            </div>
          </div>
        </div>
      </div>

    </div>
  );
}

export default ShopebyCategories;
